import PropTypes from "prop-types"
import React from "react"

const MarinaLetterhead = ({ marina, right }) => (
  <div className="flex items-start justify-between border-b-2 border-gray-900 pb-4">
    <div className="flex items-center gap-3">
      {marina.logoUrl && (
        <img
          src={marina.logoUrl}
          alt={`${marina.name} logo`}
          className="max-h-[46px] max-w-[120px] object-contain"
        />
      )}
      <div>
        <div className="text-lg font-bold leading-tight">{marina.name}</div>
        <div className="mt-0.5 text-xs leading-normal">
          {[
            marina.address?.addressLineOne,
            marina.address?.city,
            marina.address?.state,
            marina.address?.zip,
          ]
            .filter(Boolean)
            .join(" · ")}
          <br />
          {[marina.displayPhone, marina.email].filter(Boolean).join(" · ")}
        </div>
      </div>
    </div>
    <div className="text-right">{right}</div>
  </div>
)

MarinaLetterhead.propTypes = {
  marina: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    displayPhone: PropTypes.string,
    email: PropTypes.string,
    address: PropTypes.object,
  }).isRequired,
  right: PropTypes.node,
}

export default MarinaLetterhead
